import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36a3f5be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "auth-page-container",
  tabindex: "-1",
  role: "dialog"
}
const _hoisted_2 = { class: "col-left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "decoration-phone-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/phone.png",
    class: "decoration-phone"
  })
], -1))
const _hoisted_6 = { class: "col-left-content" }
const _hoisted_7 = { class: "col-right" }
const _hoisted_8 = {
  class: "modal-dialog modal-lg",
  role: "document"
}
const _hoisted_9 = { class: "modal-header" }
const _hoisted_10 = { class: "modal-title no-close cookies-modal-title" }
const _hoisted_11 = { class: "modal-body cookies-modal-body" }
const _hoisted_12 = { class: "cookie-option" }
const _hoisted_13 = { class: "cookie-option-title" }
const _hoisted_14 = { class: "cookie-option-desc" }
const _hoisted_15 = { class: "list-cookie-purposes" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hand" }, null, -1))
const _hoisted_18 = { class: "cookie-option-btn-container" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_20 = { class: "cookie-option" }
const _hoisted_21 = { class: "cookie-option-title" }
const _hoisted_22 = { class: "cookie-option-desc" }
const _hoisted_23 = { class: "list-cookie-purposes" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-column" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-plus" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-rectangle-ad" }, null, -1))
const _hoisted_27 = { class: "cookie-option-btn-container" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_29 = { class: "modal-footer cookies-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.isDark ? '/img/bg-decoration-top-dark.svg' : '/img/bg-decoration-top-light.svg',
        class: "decoration-top",
        alt: "Background decoration top"
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        src: _ctx.isDark ? '/img/bg-decoration-bottom-dark.svg' : '/img/bg-decoration-bottom-light.svg',
        class: "decoration-bottom",
        alt: "Background decoration bottom"
      }, null, 8, _hoisted_4),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t("Unlock your dreams now!")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("Our lending platform offers you the best options with incredible rates.")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("Sign up today and take control of your financial future!")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("Cookies preferences")), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("Accept only essential cookies")), 1),
            _createElementVNode("div", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.$t("We will only use the cookies required for this website to function")) + ": ", 1),
              _createElementVNode("ul", _hoisted_15, [
                _createElementVNode("li", null, [
                  _hoisted_16,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("For authentication purposes (in order to keep you logged in)")), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("In order to prevent spam or abuse of our services")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.acceptOnlyEssentialCookies && _ctx.acceptOnlyEssentialCookies(...args))),
                type: "button",
                class: "btn btn-primary"
              }, [
                _hoisted_19,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("Accept only essential cookies")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("Accept all cookies")), 1),
            _createElementVNode("div", _hoisted_22, [
              _createTextVNode(_toDisplayString(_ctx.$t("We will also use cookies for the following purposes")) + ": ", 1),
              _createElementVNode("ul", _hoisted_23, [
                _createElementVNode("li", null, [
                  _hoisted_24,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("Improving our services by collecting usage data")), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_25,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("Customizing the experience based on your preferences")), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_26,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("Showing you advertisements based on your preferences")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.acceptAllCookies && _ctx.acceptAllCookies(...args))),
                type: "button",
                class: "btn btn-primary"
              }, [
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("Accept all cookies")), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_router_link, { to: { name: 'terms' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Terms of use")), 1)
            ]),
            _: 1
          }),
          _createTextVNode(" | "),
          _createVNode(_component_router_link, { to: { name: 'cookies' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Cookies policy")), 1)
            ]),
            _: 1
          }),
          _createTextVNode(" | "),
          _createVNode(_component_router_link, { to: { name: 'privacy' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Privacy policy")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}